<template>
  <v-card class="align-stretch" height="100%" :loading="currentLeadLoading">

    <v-card-title>
      Pain Points
      <v-spacer></v-spacer>
      <v-btn class="mt-0" color="secondary" x-small @click="dialogOpen=true;"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>

    <v-card-text v-if="!currentLeadLoading">
      <v-row>
        <v-col>
          <p>Points selected</p>
          <p><b>{{isArray(currentLead.pain_points).join(', ')}}</b></p>

          <p>Notes</p>
          <p><b>{{currentLead.pain_points_notes | customPlaceholder}}</b></p>

          <p>Current Setup</p>
          <p><b>{{ currentLead.current_setup | customPlaceholder }}</b></p>
        </v-col>
      </v-row>
    </v-card-text>

    <PainPointsDialog :dialogOpen="dialogOpen" @close-dialog="dialogOpen=false;" />
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  import PainPointsDialog from './Dialogs/PainPointsDialog';

  export default {
    components: { PainPointsDialog },

    computed: { ...mapState('leads', ['currentLead','currentLeadLoading']) },

    data() {
      return {
        dialogOpen: false
      }
    },
    
    methods: {
      isArray(val) {
        if(val!==undefined&&val!==null){
          return (val.length>0)?val:[];
        }
        return [];
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
